import { render } from "./Search-Block.vue?vue&type=template&id=681dce8e"
import script from "./Search-Block.vue?vue&type=script&lang=js"
export * from "./Search-Block.vue?vue&type=script&lang=js"

import "./Search-Block.vue?vue&type=style&index=0&id=681dce8e&lang=scss"

import exportComponent from "/home/kostas/projects_on_os/coin-data-collectors-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__